/**
 * Library-neutral chart specification emitted by the `create_visualization`
 * frontend tool. The React layer maps this to ApexCharts props (see
 * `ChartRenderer.tsx`); swapping charting libraries requires no agent/backend
 * changes.
 */

export type ChartType = 'line' | 'bar' | 'area' | 'pie' | 'donut' | 'scatter' | 'radar' | 'heatmap'

export const CHART_TYPES: ChartType[] = [
  'line',
  'bar',
  'area',
  'pie',
  'donut',
  'scatter',
  'radar',
  'heatmap'
]

export interface ChartSeries {
  name: string
  /** Numeric values index-aligned to `categories`. */
  data: number[]
}

export interface ChartSpec {
  type: ChartType
  title?: string
  subtitle?: string
  /** X-axis / slice labels. */
  categories?: string[]
  series: ChartSeries[]
  xAxisLabel?: string
  yAxisLabel?: string
  stacked?: boolean
  /** Untrusted styling hints; only whitelisted keys are honoured. */
  options?: Record<string, unknown>
}
